<template>
  <div>
    <template v-if="!isMulti">
      <b-form-checkbox
        v-model="selected"
        :required="required"
        :disabled="disabled"
   
        @change="emitSelected">
        {{ checkBoxLabel }}
      </b-form-checkbox>
    </template>
    <template v-else>
      <b-form-checkbox-group      
        :options="options"
        :required="required"
        :disabled="disabled"
        :value-field="valueField"
        :text-field="textField"
        :disabled-field="disabledField"
        @change="emitSelected" />
    </template>
  </div>
</template>

<script>
  export default {
    props: {
      isMulti: {
        type: Boolean,
        default: false
      },
      options: {
        type: Array,
        default: () => []
      },
      checkBoxLabel: {type: String, default: ''},
      required: {type: Boolean, default: false},
      disabled: {type: Boolean, default: false},
      valueField: {
        type: String,
        default: 'item'
      },
      textField: {
        type: String,
        default: 'name'
      },
      disabledField: {
        type: String,
        default: 'notEnabled'
      }
    },
    data () {
      return {
        selected: this.isMulti ? [] : null
      }
    },
    methods: {
      emitSelected (ev) {
        this.selected = ev
        this.$emit('onChange', this.selected)
      }
    }
  }
</script>
